import classNames from "classnames";
import StartScreenBackground from "../../assets/img/title-background-main.png";
import Button from "../common/Button/Button";
import ProgressBar from "../common/ProgressBar/ProgressBar";
import styles from "./StartScreen.module.scss";

interface IStartScreenProps {
  assetLoadingProgress: number;
  isGameAssetsLoaded: boolean;
  onStartGame: () => void;
  isError: boolean;
  isLoading: boolean;
  highScore?: number;
  errorMessage?: string;
}

const StartScreen = ({
  assetLoadingProgress,
  isGameAssetsLoaded,
  onStartGame,
  isError,
  isLoading,
  highScore = 100,
  errorMessage,
}: IStartScreenProps) => {
  return (
    <div className={classNames(styles.container, "px-24")}>
      {/* TODO: Add title and description in future if approved by client */}
      {/* <div className={styles.title}>
        <h1 className={classNames(styles.titleText, "text1-h2-500 ")}>
          MathQuest Adventure
        </h1>
        <p className={classNames(styles.titleDescription, "text2-h6-300")}>
          Practice addition, subtraction, multiplication & division through fun.
        </p>
      </div> */}
      <img
        className={styles.background}
        src={StartScreenBackground}
        alt="Start Screen Background"
      />
      <div className={classNames(styles.actionContainer, "mt-24")}>
        {isError ? (
          <div className={styles.errorContainer}>
            <p className={styles.errorText}>
              {errorMessage ||
                "An error occurred while loading the game. Please try again later."}
            </p>
          </div>
        ) : isGameAssetsLoaded && !isLoading ? (
          <Button className={styles.startButton} onClick={onStartGame}>
            Play Now
          </Button>
        ) : (
          <ProgressBar
            progress={isLoading ? 5 : assetLoadingProgress}
            showPercentage={false}
          />
        )}

        {isGameAssetsLoaded && highScore && highScore > 0 && (
          <div className={styles.highScoreContainer}>
            <p className={styles.highScoreText}>High Score: {highScore}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StartScreen;
